export default "__VITE_ASSET__DhnJ8mUO__"